/**
 * This Software is the property of dotfly and is protected
 * by copyright law - it is NOT Freeware.
 *
 * Any unauthorized use of this software without a valid license key
 * is a violation of the license agreement and will be prosecuted by
 * civil and criminal law.
 *
 * @category   Hide Billing Form Business Fields
 * @author     Anna Morawe <anna.morawe@dotfly.de>
 * @license    http://www.dotfly.de Commercial
 * @link       http://www.dotfly.de
 */

const BillingForm = () => {

    let _oBillingForm = document.querySelectorAll('.js-billing');

    for (var i = 0; i < _oBillingForm.length; i++) {

        let _oUserTypeBusiness  = document.getElementById('SelectUserBusiness');
        let _oUserTypePrivate   = document.getElementById('SelectUserPrivate');

        let _oHiddenFields      = document.querySelector('.hide--business');

        /* Show fields when "Business" is clicked */
        _oUserTypeBusiness.addEventListener('click', function(){
            if (_oUserTypeBusiness.checked) {
                _oHiddenFields.style.display = 'block';
            }
        });

        /* Hide fields when "Private" is clicked */
        _oUserTypePrivate.addEventListener('click', function(){
            if (_oUserTypePrivate.checked) {
                _oHiddenFields.style.display = 'none';
            }
        });
    }

};

BillingForm();
